<template>
  <router-view />
</template>

<script>
export default {
  name: 'ReservationPaymentRequestsIndex'
}
</script>
